import { createApi } from "@reduxjs/toolkit/query/react";
import { setToken } from "../../features/userSlice";
import CustomFetchBase from "../CustomFetchBase";

export const AuthApi = createApi({
  reducerPath: "AuthApi",
  baseQuery: CustomFetchBase,
  endpoints: (builder) => ({
    verifyOtp: builder.mutation({
      query: (data) => ({
        url: "/admin/login/verify-otp",
        method: "POST",
        body: data,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      onQueryStarted: async (args, { dispatch, queryFulfilled }) => {
        try {
          const { data } = await queryFulfilled;

          if (
            data &&
            (data?.data?.admin?.role === "admin" ||
              data?.data?.admin?.role === "super_admin")
          ) {
            dispatch(setToken(data?.data?.token));
          }
        } catch (error) {}
      },
      invalidatesTags: ["AuthApi"],
    }),

    loginUser: builder.mutation({
      query: (data) => ({
        url: "/admin/login/request-otp",
        method: "POST",
        body: data,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["AuthApi"],
    }),

    resendOtp: builder.mutation({
      query: (data) => ({
        url: "/admin/login/request-otp",
        method: "POST",
        body: data,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["AuthApi"],
    }),
    getAllUsers: builder.query({
      query: ({ page, role, status, verified, search, licenseExpiryStatus }) => {
        const params = new URLSearchParams();
        params.append("page", page);
        if (role) params.append("role", role);
        if (status) params.append("status", status);
        if (verified) params.append("verified", verified);
        if (search) params.append("search", search);
        if (licenseExpiryStatus) params.append("licenseExpiryStatus", licenseExpiryStatus);

        return {
          url: `/users/admin/users?${params.toString()}`,
          method: "GET",
          headers: {
            "Content-Type": "application/json; charset=UTF-8",
          },
        };
      },
      invalidatesTags: ["AuthApi"],
    }),
    getUser: builder.query({
      query: (id) => ({
        url: `/users/${id}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["AuthApi"],
    }),

    createUser: builder.mutation({
      query: (data) => ({
        url: "/users",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["AuthApi"],
    }),
    editUser: builder.mutation({
      query: ({ id, data }) => ({
        url: `/users/${id}`,
        method: "PUT",
        body: data,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["AuthApi"],
    }),
    getOnlineDrivers: builder.query({
      query: ({ vehicleType, page, limit, search } = {}) => {
        const params = new URLSearchParams();
        if (vehicleType) params.append("vehicleType", vehicleType);
        if (page) params.append("page", page);
        if (limit) params.append("limit", limit);
        if (search) params.append("search", search);

        return {
          url: `/users/drivers/online${
            params.toString() ? `?${params.toString()}` : ""
          }`,
          method: "GET",
          headers: {
            "Content-Type": "application/json; charset=UTF-8",
          },
        };
      },
      providesTags: ["OnlineDrivers"],
      // Auto-refetch every 30 seconds
      pollingInterval: 30000,
    }),
  }),
});

export const {
  useLoginUserMutation,
  useVerifyOtpMutation,
  useResendOtpMutation,
  useGetAllUsersQuery,
  useLazyGetAllUsersQuery,
  useCreateUserMutation,
  useEditUserMutation,
  useGetUserQuery,
  useGetOnlineDriversQuery,
  useLazyGetOnlineDriversQuery,
} = AuthApi;
